import React from 'react';
import { useInfiniteHits } from 'react-instantsearch';
import CustomHit from '../CustomHit';

const InfiniteHits = () => {
    const { items, isLastPage, sendEvent, showMore } = useInfiniteHits();

    return (
        <div style={{ backgroundColor: 'white' }}>
            <div className="container">
                {items.map((hit) => (
                    <CustomHit
                        hit={hit}
                        key={hit.objectID}
                        onClick={() => sendEvent('click', hit, 'Article Clicked')}
                    />
                ))}

                {!isLastPage && (
                    <button style={{ marginBottom: '45px' }} onClick={() => showMore()}>
                        Show more
                    </button>
                )}
            </div>
        </div>
    );
};

export default InfiniteHits;
